var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource',{attrs:{"resource":"automaticMessageRule","resourceName":"Automatische Nachrichten","attributes":[
    {
      name: 'sender',
      label: 'Absender',
      type: 'FakeSelector'
    },
    {
      name: 'send_to_gender',
      label: 'Sende an',
      type: 'SexSelector',
      multiSelect: true
    },
    {
      name: 'message',
      label: 'Nachricht(en)',
      type: 'MessagePool'
    },
    {
      name: 'delay',
      label: 'Verzögerung',
      type: 'DateRangeSliderSelector',
      max: 30,
      min: 0
    },
    {
      name: 'send_to_users_with_dialogues',
      label: 'An Nutzer mit aktiven Dialogen schicken?',
      type: 'CheckboxSelector'
    }
  ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Regel für automatische Nachrichten erstellen")]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('i',{staticClass:"fas fa-question-circle text-info"}),_vm._v("\n        Hier können automatische Nachrichten angelegt werden. Es ist das\n        entsprechende Fake auszuwählen und die Nachricht oder mehre\n        Nachrichten. Auch können unterschiedliche Nachrichtentypen verwendet\n        werden. Als Hilfe können sog. Platzhalter verwendet werden, die im\n        Text etwas dynamik reinbringen. Das sind beispielsweise der Name des\n        Mitglieds, das Alter des Fakes usw.\n        "),_c('br'),_vm._v("\n        Unten kann angegeben werden, wann frühstens diese automatische\n        Nachricht gesendet wird. Gezählt wird der Zeitpunkt, an dem das\n        Mitglied sich vollständig im System verifiziert hat\n        ("),_c('code',[_vm._v("DOI")]),_vm._v("). Zusätzlich kann eine Verzögerung definiert werden.\n        Innerhalb dieses Bereiches wird per Zufall ein Zeitpunkt festgelegt,\n        wann die automatische Nachricht versendet wird.\n        "),_c('br'),_vm._v("\n        Sollte innerhab dieser Zeitspanne das Fake und das Mitglied bereits\n        einen aktiven Dialog haben, wird die automatische Nachricht\n        "),_c('strong',[_vm._v("nicht")]),_vm._v(" versendet. Mit aktivieren der Checkbox: \"An\n        Nutzer mit aktivem Dialogen schicken?\" wird diese Regel umgangen und\n        dennoch verschickt.\n      ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }